import { defineMessages } from "react-intl";

import {
	hasOccurredMessages,
	validator
} from "lib/build/forms/ltx/phase-i/medical-history/liver-related-complications/hepatorenalSyndrome";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	hepatorenalSyndrome: {
		id: "form.hepatorenalSyndrome",
		defaultMessage: "Hepatorenalis syndroma"
	},
	hasOccurred: {
		id: "form.hepatorenalSyndrome.hasOccurred",
		defaultMessage: "Fordult-e elő a betegnél hepatorenalis syndroma?"
	}
});

const fields: { [key: string]: FieldData } = {
	hasOccurred: {
		type: "field",
		path: ["hasOccurred"],
		label: messages.hasOccurred,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: hasOccurredMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.hasOccurred }] }]
};

export const node: LeafNode = {
	id: "hepatorenalSyndrome",
	value: {
		title: messages.hepatorenalSyndrome,
		validator,
		fieldset,
		isImportant: false
	}
};
